<template>
  <v-responsive :aspect-ratio="16/9">
    <base-chart :option="option"></base-chart>
  </v-responsive>
</template>

<script>
import BaseChart from '@/components/Charts/Base'

export default {
  components: { BaseChart },
  props: {
    datasets: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    option () {
      const option = {
        legend: {},
        tooltip: {},
        dataset: {
          dimensions: this.dimensions,
          source: this.datasets
        },
        xAxis: { type: 'category' },
        yAxis: {},
        series: this.series
      }

      return option
    },
    dimensions () {
      return Object.keys(this.datasets[0])
    },
    series () {
      const seriesCount = this.dimensions.length - 1

      const seriesArray = []
      let i = 0
      while (i < seriesCount) {
        const newSeriesItem = { type: 'bar' }
        seriesArray.push(newSeriesItem)
        i++
      }

      return seriesArray
    }
  }
}
</script>
